import React, { useState } from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { FaUserCircle, FaThLarge, FaExchangeAlt, FaLayerGroup } from 'react-icons/fa';
import AccountsDashboard from './AccountsDashboard';
import GeneralDashboard from './GeneralDashboard';
import AccountComparator from './AccountComparator';
import AccountGroups from './AccountGroups';
import './socialAnalytics.css';

/**
 * Contenedor de Social Media (analítica de redes) con verticales:
 *   - "Redes Sociales"      → analítica de cuentas: Instagram, Facebook, TikTok
 *   - "Análisis Competencia"→ dashboard general de competencia
 *   - "Comparador"          → comparación entre cuentas
 *   - "Agrupaciones"        → grupos de cuentas
 *
 * La vertical de "Noticias" (monitoreo por keyword con SerpAPI) se extrajo a su
 * propia sección de menú (ruta /noticias → HomePage), fuera de este contenedor.
 *
 * Layout en flex-column de altura completa: el switch arriba (altura fija) y el
 * panel activo ocupa el resto con min-height:0 para que el scroll interno de
 * cada vertical siga funcionando.
 */
export default function MediaMonitoring() {
    const { user } = useAuthenticator((context) => [context.user]);
    const [vertical, setVertical] = useState('account');

    return (
        <div className="sa-root">
            <div className="sa-vertical-switch">
                <button
                    className={vertical === 'account' ? 'active' : ''}
                    onClick={() => setVertical('account')}>
                    <FaUserCircle /> Redes Sociales
                </button>
                <button
                    className={vertical === 'general' ? 'active' : ''}
                    onClick={() => setVertical('general')}>
                    <FaThLarge /> Análisis Competencia
                </button>
                <button
                    className={vertical === 'compare' ? 'active' : ''}
                    onClick={() => setVertical('compare')}>
                    <FaExchangeAlt /> Comparador
                </button>
                <button
                    className={vertical === 'groups' ? 'active' : ''}
                    onClick={() => setVertical('groups')}>
                    <FaLayerGroup /> Agrupaciones
                </button>
            </div>

            {vertical === 'account' && (
                <div className="sa-pane sa-pane-scroll">
                    <AccountsDashboard username={user?.username} />
                </div>
            )}

            {vertical === 'general' && (
                <div className="sa-pane sa-pane-scroll">
                    <GeneralDashboard username={user?.username} />
                </div>
            )}

            {vertical === 'compare' && (
                <div className="sa-pane sa-pane-scroll">
                    <AccountComparator username={user?.username} />
                </div>
            )}

            {vertical === 'groups' && (
                <div className="sa-pane sa-pane-scroll">
                    <AccountGroups username={user?.username} />
                </div>
            )}
        </div>
    );
}
